import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MasterModelService {

  constructor(
    private readonly http: HttpClient
  ) { }

  saveModelDetails(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/vehicle-model';
    return this.http.post(url, payload);
  }

  saveTyreModelDetails(payload:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/tyres-model';
    return this.http.post(url, payload);
  }

  getMakeDetails(pageNumber?:any,searchTerm?:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/vehicle-make';
    return this.http.get(url,{ params: pageNumber,...searchTerm });
  }

  getModelDetails(searchTerm?:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/vehicle-model';
    return this.http.get(url,{ params:searchTerm});
  }

  getTyreModelList(pageNumber: any, search?: any): Observable<any> {
    let url = environment.BASE_URL + '/v1/tyres-model/list';
    return this.http.get(url, { params: { ...pageNumber, ...search } });
  }

  getTyreModelDetails(pageNumber:any,search?:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/tyres-model';
    return this.http.get(url,{ params: { ...pageNumber, ...search }});
  }

  getPendingTyreModelDetails(pageNumber:any,search?:any): Observable<any>{
    let url = environment.BASE_URL + '/v1/tyres-model/pending';
    return this.http.get(url,{ params: { ...pageNumber, ...search }});
  }

  activePendingTyreModel(payload:any,id:any): Observable<any>{
    let url = environment.BASE_URL + `/v1/tyres-model/${id}/update-status`;
    return this.http.put(url,payload);
  }

  getDealerDetails(): Observable<any>{
    let url = environment.BASE_URL + '/v1/dealers';
    return this.http.get(url);
  }

  updateModelDetails(payload:any,modelId:any): Observable<any>{
    let url = environment.BASE_URL + `/v1/vehicle-model/${modelId}`;
    return this.http.put(url,payload);
  }

  updateTyrePattern(payload:any,modelId: any): Observable<any>{
    let url = environment.BASE_URL + `/v1/tyres-model/${modelId}`;
    return this.http.put(url,payload);
  }

  getMergeSkulist(page: number = 0) {
    let url = environment.BASE_URL + `/v1/tyres-model/merge-list?page=${page}`;
    return this.http.get(url);
  }

  createMerge(payload: any) {
    let url = environment.BASE_URL + '/v1/tyres-model/merge';
    return this.http.post(url, payload);
  }

  
}
